document.addEventListener("animationend", function (e) {
    if (
        e.animationName === "sb_logo-svg_wing-load" ||
        e.animationName === "sb_logo-svg_head-load"
    ) {
        e.target.classList.add("s_load-done");
    }
    if (
        e.animationName === "sb_logo-svg_wing-hover" ||
        e.animationName === "sb_logo-svg_head-hover"
    ) {
        e.target.classList.remove("s_logo-hover");
    }
});

document.addEventListener("mouseover", function (e) {
    var link = e.target.closest && e.target.closest("a");
    if (!link) return;
    if (e.relatedTarget && link.contains(e.relatedTarget)) return;
    var wing = link.querySelector(".sb_logo-svg_bird-full-wing");
    var head = link.querySelector(".sb_logo-svg_bird-head");
    if (wing && !wing.classList.contains("s_logo-hover"))
        wing.classList.add("s_logo-hover");
    if (head && !head.classList.contains("s_logo-hover"))
        head.classList.add("s_logo-hover");
});
